import React, { useState, useEffect } from "react";
import classes from "./style.module.scss";
import sharedClasses from "../style.module.scss";
import InfoTooltip from "components/InfoTooltip";
import WarningTooltip from "components/WarningTooltip";
import { createInputFocusHandler, createInputKeyDownHandler } from "components/Input";

export default ({
    name,
    label,
    input = {},
    meta = {},
    hideLabel,
    large,
    className,
    info = "",
    warning = "",
    quantity = false,
    setValue,
    setTouched = false,
    disabled = false,
    parentError = false,
    style = {},
    min = 0,
    max = 100,
    step = 1,
    val: initialValue = 1,
    onBlurAction = () => {},
}) => {
    const [touched, toggleTouched] = useState(false);
    const { invalid = false, error = "" } = meta;
    const { value, onChange } = input;
    const isTouched = touched || setValue || setTouched;
    const [val, setVal] = useState(initialValue);

    const classNames = [
        classes.inputField,
        className && className,
        large && classes.large,
        quantity && classes.hasQuantity,
        (parentError || (invalid && isTouched)) && classes.invalid,
    ].filter((c) => c);

    const handleIncrement = () => {
        if (!disabled && val < max) {
            const newValue = Math.min(val + step, max);
            setVal(newValue);
            if (onChange) onChange(newValue);
            if (onBlurAction) onBlurAction(newValue);
        }
    };

    const handleDecrement = () => {
        if (!disabled && val > min) {
            const newValue = Math.max(val - step, min);
            setVal(newValue);
            if (onChange) onChange(newValue);
            if (onBlurAction) onBlurAction(newValue);
        }
    };

    const handleChange = (e) => {
        var newValue = parseFloat(e.target.value);
        if (isNaN(newValue)) newValue = "";
        
        if (newValue >= min && newValue <= max) {
            setVal(newValue);
            if (onChange) onChange(newValue);
        }
    };

    const handleBlur = (e) => {
        if (e.target.value === "") setVal(0);
        if (onBlurAction) onBlurAction(parseInt(e.target.value) || 0);
        toggleTouched(true);
    };

    useEffect(() => {
        if (setValue || setValue === 0) {
            setVal(setValue);  // Update the internal state
            if (onChange) onChange(setValue);  // Trigger onChange if it exists
        }
    }, [setValue]);

    const handleInputFocus = createInputFocusHandler({
        value: val,
        displayValues: [val],
        onClear: () => setVal(""),
    });

    const handleInputKeyDown = createInputKeyDownHandler({});

    return (
        <div className={classNames.join(" ")} style={style}>
            {info && <InfoTooltip className={sharedClasses.infoTooltip} info={info} />}
            {warning && (
                <WarningTooltip className={`${classes.warningTooltip} ${info && classes.pushLeft}`} warning={warning} />
            )}
            <label className={hideLabel && "invisible"} htmlFor={name}>
                {label}
            </label>
            <div className={`${classes.counterContainer} ${warning && !disabled ? classes.warningContainer : ''}`}>
                <button
                    type="button"
                    className={`${classes.decrementButton} ${disabled || val <= min ? classes.disabled : ""}`}//{classes.decrementButton}
                    onClick={handleDecrement}
                    disabled={disabled || val <= min}
                >
                    -
                </button>
                <input
                    type="number"
                    id={name}
                    className={classes.inputField}
                    value={val} 
                    onChange={handleChange}
                    disabled={disabled}
                    min={min}
                    max={max}
                    step={step}
                    onBlur={(e) => handleBlur(e)}
                    onFocus={handleInputFocus}
                    onKeyDown={handleInputKeyDown}
                />
                <button
                    type="button"
                    className={`${classes.incrementButton} ${disabled || val >= max ? classes.disabled : ""}`}//{classes.incrementButton}
                    onClick={handleIncrement}
                    disabled={disabled || val >= max}
                >
                    +
                </button>
            </div>
        </div>
    );
};
